import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';import { DelegateAccessRestrictedMenu, isPartnerPortalUser, UserTypeEnum } from 'src/app/services/common/constant.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { RoleManagementService } from 'src/app/services/role-management.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { GiftcardComponent } from "../../components/giftcard/giftcard.component";
import { MatDrawer } from '@angular/material/sidenav';
import { Clipboard } from '@angular/cdk/clipboard';
import { GlobalService } from 'src/app/services/common/global.service';
import { BusinessUserService } from 'src/app/services/business-user.service';
import { RetailStoreService } from 'src/app/services/retail-store.service';
import { UserService } from 'src/app/services/user.service';
// import { AnalyticsComponent } from 'src/app/components/analytics/analytics.component';
import { TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilityService } from 'src/app/services/utility.service';
import { AlertService } from 'src/app/services/common/alert.service';
import QRCode from 'qrcode';
import { firstValueFrom } from 'rxjs';
import { GlobalVariables } from 'global-variables';

declare var bootstrap: any;


type ShareLinks = {
  facebook: string;
  linkedin: string;
  twitter: string;
  whatsapp: string;
};

@Component({
  selector: 'app-admin-sidenav',
  templateUrl: './admin-sidenav.component.html',
  styleUrls: ['./admin-sidenav.component.scss']
})
export class AdminSidenavComponent implements OnInit, AfterViewInit {
  @ViewChild(GiftcardComponent, { static: false }) giftCardComponent!: GiftcardComponent;

  @Input() drawer!: MatDrawer;
  menuRightData: any[] = [];
  menuRights: any[] = [];
  userData: any;
  isPWA = false;
  businessQRCode: any;
  businessQRValue: any;
  userID: any = "";
  currentUserData: any;
  previewsLogo: string[] = [];
  encodeQrCodeValue = "";
  qrCodeValue = "";
  baseurl: string = '';

  businessId?: string;

  shareLinks: ShareLinks = { facebook: '#', linkedin: '#', twitter: '#', whatsapp: '#' };
  featuredList: any;
  showPublishDealCatalog = false;
  publishDealCatalog = false;
  publishingDealCatalog = false;

  constructor(private storageService: StorageService,
    private router: Router,
    private _userInfoService: UserInfoService,
    private roleManagementService: RoleManagementService,
    private clipboard: Clipboard,
    private globalService: GlobalService,
    private businessuserService: BusinessUserService,
    private retailStoreService: RetailStoreService,
    private userService: UserService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private utilityService: UtilityService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService

  ) { }

  ngOnInit(): void {
    this.baseurl = environment.shareUrl;
    this.currentUserData = JSON.parse(this.storageService.getValue(StorageKey.currentUser));
    //console.log("currentUserData", this.currentUserData)
    this.userID = this.currentUserData.id;
    this.utilityService.getProductDetails(this.userID).subscribe(result => {
      this.featuredList = result.data
      //console.log("this.featuredList", result.data)
    })
    this.loadSidebarCopyUrl();
    this.loadPublishDealCatalog();
    this.getUserDetail();
    this.storageService.menuListSubject.subscribe(message => {
      this.setMenuList();
    });
    if (this.storageService.getValue(StorageKey.menuRights)) {
      this.setMenuList();
    }

    this.userData = this._userInfoService.getUserInfo();

    this.isPWA = window.matchMedia('(display-mode: standalone)').matches;
    window.matchMedia('(display-mode: standalone)').addEventListener('change', (evt) => {
      this.isPWA = evt.matches;
      this.setMenuList();
    });
    if (this.isPWA)
      this.setMenuList();
  }
  shareFacebook() {
    let shareUrl: string;
    shareUrl = `${this.baseurl}#/deal/organization?organizationId=${this.getCurrentUserId()}`;
    //console.log(shareUrl);

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      '_blank',
      'noopener,noreferrer'
    );
  }
  share(platform: 'facebook' | 'linkedin' | 'twitter' | 'whatsapp' | 'instagram' | 'copy') {
    let url = this.catalogHomeUrl() || this.getTargetUrl() || this.buildShareUrl();
    const title = 'Check out these deals on Scanfluence';
    const text = 'Found something interesting for you:';
    if (!url) return;

    if (navigator.share && platform === 'copy') {
      navigator.share({ title, text, url }).catch(() => { });
      return;
    }

    if (['facebook', 'linkedin', 'twitter', 'whatsapp', 'instagram'].includes(platform))
      url = this.addSourceToUrl(url, platform);
    const u = encodeURIComponent(url);
    const t = encodeURIComponent(title);
    const msg = encodeURIComponent(`${text} ${url}`);

    switch (platform) {
      case 'facebook':
        this.openPopup(`https://www.facebook.com/sharer/sharer.php?u=${u}`);
        return;

      case 'linkedin':
        this.openPopup(`https://www.linkedin.com/sharing/share-offsite/?url=${u}`);
        return;

      case 'twitter': // X
        this.openPopup(`https://twitter.com/intent/tweet?text=${t}&url=${u}`);
        return;

      case 'whatsapp':
        this.openPopup(`https://wa.me/?text=${msg}`);
        return;

      case 'instagram': {

        this.copyToClipboard(url);
        if (this.snack?.open) {
          const ref = this.snack.open('Link copied. Open Instagram now?', 'Open', {
            duration: 2500,
            horizontalPosition: 'center',
            verticalPosition: 'bottom'
          });

          const sub = ref.onAction().subscribe(() => {
            window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
          });

        } else {
          alert('Link copied. Opening Instagram…');
          window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
        }
        return;
      }

      case 'copy':
        this.copyToClipboard(url);
        this.snack?.open?.('Link copied to clipboard', 'OK', { duration: 2000 });
        return;
    }
  }
  // private openPopup(shareUrl: string) {
  //   window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=650');
  // }
  private openPopup(shareUrl: string) {
    const w = window.open(shareUrl, '_blank');   // no features => new tab (browser prefs permitting)
    if (w) w.opener = null;                      // keep noopener behavior
    else window.location.href = shareUrl;        // popup blocked fallback
  }

  private copyToClipboard(text: string) {
    if (!text) return;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
    } else {
      this.fallbackCopy(text);
    }
  }

  private fallbackCopy(text: string) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch { }
    document.body.removeChild(ta);
  }

  private buildShareUrl(): string {
    const base = (this.baseurl || window.location.origin + '/');
    const id = this.getCurrentUserId();
    if (!id) return '';
    return `${base}#/deal/organization?organizationId=${id}`;
  }

  private getCurrentUserId(): string | null {
    try {
      const raw = localStorage.getItem('currentUser');
      if (!raw) return null;
      const u = JSON.parse(raw);
      return u?.id ?? u?._id ?? null;
    } catch { return null; }
  }
  setMenuList() {
    this.menuRightData = this.storageService.getAllMenuRights();

    var currentUserData = JSON.parse(this.storageService.getValue(StorageKey.currentUser));
    if (currentUserData?.userType) {
      if (currentUserData.userType.includes(UserTypeEnum.RETAILER) && this.isPWA) {
        this.menuRightData = this.menuRightData.filter(x => x.name == "Validate & Reedem")
        this.router.navigate(['/admin/coupons/validate-coupon']);
      } else {
        if (currentUserData.userType.includes(UserTypeEnum.ORGANIZATION) && currentUserData.userType.includes(UserTypeEnum.RETAILER)) {
          this.menuRightData = this.menuRightData.filter(x => x.name != "Active Campaigns");
        }
      }
      if (currentUserData.delegateAccess) this.menuRightData = this.menuRightData.filter(x => !DelegateAccessRestrictedMenu.includes(x.name));
    }

    this.menuRightData.forEach(element => {
      let data_parent = this.setMenuIcon(element);

      element.routerLink = data_parent.routerLink;
      element.icon = data_parent.icon;
      element.exact = data_parent.exact;
      element.showSubmenu = false;
      if (element.childMenus) {
        element.childMenus.forEach((childElement: any) => {
          let data_child = this.setMenuIcon(childElement);
          childElement.routerLink = data_child.routerLink;
          childElement.icon = data_child.icon;
          childElement.exact = data_child.exact;
        });
      }
    });

    this.menuRights = this.menuRightData;
  }
  collapseAll(name: string) {
    this.menuRights.forEach(el => {
      if (el.name !== name) el.showSubmenu = false;
      else el.showSubmenu = !el.showSubmenu;
    });
  }

  setMenuIcon(element: any) {
    var model = Object.assign({});

    if (element.name == 'Dashboard') {
      const types: string[] = this.currentUserData?.userType ?? [];
      model.routerLink = isPartnerPortalUser(types) ? '/admin/partner-portal' : '/admin/dashboard';
      model.icon = 'dashboard';
      model.exact = false;
    }
    else if (element.name == 'Campaigns') {
      model.routerLink = "/admin/campaigns";
      model.icon = "redeem";
      model.exact = true;
    }
    else if (element.name == 'Active Campaigns') {
      model.routerLink = "/admin/campaigns/active-campaigns";
      model.icon = "verified_user";
      model.exact = true;
    }
    else if (element.name == 'Campaign Stats') {
      model.routerLink = "/admin/campaign-stats";
      model.icon = "assignment";
      model.exact = false;
    }
    else if (element.name == 'Performance Report') {
      model.routerLink = "/admin/reports/campaign-performance-report";
      model.icon = "assignment";
      model.exact = false;
    }
    else if (element.name == 'Campaign Settlement') {
      model.routerLink = "/admin/reports/campaign-settlement-report";
      model.icon = "assignment";
      model.exact = false;
    }
    else if (element.name == 'Retail Stores') {
      model.routerLink = "/admin/retail-store";
      model.icon = "store";
      model.exact = false;
    }
    else if (element.name == 'Reedemed Coupons') {
      element.name = "Redeemed Coupons"
      model.routerLink = "/admin/coupons";
      model.icon = "receipt";
      model.exact = true;
    }
    else if (element.name == 'Validate & Reedem') {
      element.name = "Validate & Redeem"
      model.routerLink = "/admin/coupons/validate-coupon";
      model.icon = "task_alt";
      model.exact = true;
    }
    else if (element.name == 'Items') {
      element.name = "Items"
      model.routerLink = "/admin/products";
      model.icon = "how_to_vote";
      model.exact = false;
    }
    else if (element.name == 'Collection') {
      element.name = "Collection";
      model.routerLink = "/admin/collection";
      model.icon = "collections";
      model.exact = false;
    }
    else if (element.name == 'Category Management') {
      element.name = "Category Management";
      model.routerLink = "/admin/category-management";
      model.icon = "category";
      model.exact = false;
    }
    else if (element.name == 'Users') {
      const types: string[] = this.currentUserData?.userType ?? [];
      model.routerLink = isPartnerPortalUser(types) ? '/admin/partner-portal/users' : '/admin/users';
      model.icon = 'person';
      model.exact = false;
    }
    else if (element.name == 'Banner') {
      model.routerLink = "/admin/banner";
      model.icon = "person";
      model.exact = false;
    }
    else if (element.name == 'Business Users') {
      model.routerLink = "/admin/business-users";
      model.icon = "person";
      model.exact = false;
    }
    else if (element.name == 'Customers') {
      model.routerLink = "/admin/customers";
      model.icon = "supervised_user_circle";
      model.exact = false;
    }
    else if (element.name == 'Subscriptions') {
      const types: string[] = this.currentUserData?.userType ?? [];
      model.routerLink = isPartnerPortalUser(types) ? '/admin/partner-portal/report' : '/admin/subscriptions';
      model.icon = 'credit_card';
      model.exact = false;
    }
    else if (element.name == 'Role Management') {
      model.routerLink = "/admin/role-management";
      model.icon = "playlist_add_check";
      model.exact = false;
    }
    else if (element.name == 'Contact Us') {
      model.routerLink = "/admin/contact-us";
      model.icon = "mail_outline";
      model.exact = false;
    }
    else if (element.name == 'Notifications') {
      model.routerLink = "";
      model.icon = "notifications_active";
      model.exact = false;
    }
    else if (element.name == 'Retailers') {
      model.routerLink = "/admin/notification/retailer";
      model.icon = "contact_mail";
      model.exact = false;
    }
    else if (element.name == 'Customers') {
      model.routerLink = "/admin/notification/customer";
      model.icon = "business_center";
      model.exact = false;
    }
    else if (element.name == 'Retail Store Stats') {
      model.routerLink = "/admin/retail-store-stats";
      model.icon = "assignment";
      model.exact = false;
    }
    else if (element.name == 'Store Summary') {
      model.routerLink = "/admin/reports/store-summary-report";
      model.icon = "assignment";
      model.exact = false;
    }
    else if (element.name == 'Store Transactions') {
      model.routerLink = "/admin/reports/transaction-report-by-store";
      model.icon = "assignment";
      model.exact = false;
    }
    else if (element.name == 'Daily Summary') {
      model.routerLink = "/admin/reports/daily-summary";
      model.icon = "assignment";
      model.exact = false;
    }
    else if (element.name == 'Organization Users') {
      model.routerLink = "/admin/organization-users";
      model.icon = "person";
      model.exact = false;
    }
    else if (element.name == 'Organization Role Management') {
      model.routerLink = "/admin/organization-role-management";
      model.icon = "playlist_add_check";
      model.exact = false;
    }
    else if (element.name == 'Games') {
      model.routerLink = "/admin/games";
      model.icon = "games";
      model.exact = false;
    }
    else if (element.name == 'Delegate Access') {
      model.routerLink = "/admin/delegate-access";
      model.icon = "person";
      model.exact = false;
    }
    else if (element.name == 'Training Video') {
      model.routerLink = "/admin/video";
      model.icon = "person";
      model.exact = false;
    }
    else if (element.name == 'Giftcard') {
      model.routerLink = "/admin/giftcard";
      model.icon = "person";
      model.exact = false;
    }
    else if (element.name == 'Analytics') {
      model.routerLink = "/admin/analytics";
      model.icon = "assessment";
      model.exact = false;
    }
    else if (element.name == 'Members') {
      model.routerLink = "/admin/vcard-contact/members";
      model.icon = "people";
      model.exact = false;
    }
    else if (element.name == 'Roles') {
      model.routerLink = "/admin/vcard-contact/roles";
      model.icon = "assignment_ind";
      model.exact = false;
    }
    else if (element.name == 'Contacts') {
      model.routerLink = "/admin/vcard-contact/contact";
      model.icon = "contacts";
      model.exact = false;
    }
    else if (element.name == 'Events') {
      model.routerLink = "/admin/vcard-contact/events";
      model.icon = "event";
      model.exact = false;
    }
    else if (element.name == 'Company') {
      model.routerLink = "/admin/vcard-contact/company-profile";
      model.icon = "company";
      model.exact = false;
    }
    //   else if (element.name == 'View Page') {
    //   model.routerLink = "/admin/view-page";
    //   model.icon = "person";
    //   model.exact = false;
    // }
    else { }
    return model;
  }

  ngAfterViewInit(): void {
    if (this.giftCardComponent) {
      //console.log('GiftCardComponent initialized successfully');
    } else {
      // console.error('GiftCardComponent failed to initialize');
    }
  }

  onClickMenu(name?: string) {
    if (Number(window.innerWidth) <= 768 && this.drawer) {
      this.drawer.close();
    }

    if (name === 'Giftcard') {
      if (this.giftCardComponent) {
      } else {
        console.error('GiftcardComponent is not initialized!');
      }
    }

    if (name) this.collapseAll(name);

    this.roleManagementService.access().subscribe((response: any) => {
      if (response.success) {
        this.menuRights = response.data;
        this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
      }
      else {
        this.menuRights = [];
        this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
      }
      this.storageService.menuListSubject.next(true);
      if (name) this.collapseAll(name);
    })

  }

  onClickDownloadQrCode() {
    const finalUrl = this.isStoreOnlyUser() ? this.businessQRValue : this.buildFinalShareUrl();
    if (!finalUrl) return;

    const qrApi = `https://quickchart.io/qr?text=${encodeURIComponent(finalUrl)}&margin=2&size=600`;

    fetch(qrApi)
      .then(res => res.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.userID || 'qr';
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        try {
          const blobData = this.globalService.convertBase64ToBlob(this.businessQRCode);
          const blob = new Blob([blobData], { type: 'image/png' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = this.userID || 'qr';
          link.click();
          window.URL.revokeObjectURL(url);
        } catch { /* no-op */ }
      });
  }

  getUserDetail() {
    this.userService.detail(this.userID).subscribe((response: any) => {
      //console.log("response", response)
      if (response) {
        var data = response.data;
        if (data?.company_logo) {
          this.previewsLogo = [];
          this.previewsLogo.push(data.company_logo)
        }
      }
    });
  }

  openPricing(event: Event): void {
    event.preventDefault();
    window.open('https://scanfluence.com/price.html', '_blank', 'noopener');
  }

  private isHttpUrl(v: string): boolean {
    return /^https?:\/\//i.test(v);
  }

  public getTargetUrl(): string {

    const raw = (this.qrCodeValue || '').trim();
    if (!raw) return '';

    if (this.isHttpUrl(raw)) {
      return raw;
    }

    if (/^www\./i.test(raw) || /^[\w-]+\.[\w.-]+(\/.*)?$/.test(raw)) {

      return `https://${raw}`;
    }
    return '';
  }

  private customerOrigin(): string {
    const candidates = [
      GlobalVariables.appCustomerURL,
      this.baseurl,
      environment.shareUrl,
      this.getTargetUrl(),
      this.businessQRValue,
    ];
    for (const candidate of candidates) {
      const raw = String(candidate || '').trim();
      if (!raw || raw.startsWith('data:')) continue;
      try {
        return new URL(this.isHttpUrl(raw) ? raw : `https://${raw}`).origin;
      } catch {
        continue;
      }
    }
    return '';
  }

  /** Catalog home, e.g. https://host/#/mixology — same page UAT opens from the sidebar. */
  private catalogHomeUrl(): string {
    if (this.isStoreOnlyUser()) return '';
    const slug = String(this.currentUserData?.slug || '').trim();
    const origin = this.customerOrigin();
    if (!slug || !origin) return '';
    return `${origin}/#/${slug}`;
  }

  private getShareableImageUrl(): string {
    const raw = (this.businessQRCode || '').trim();
    return this.isHttpUrl(raw) ? raw : '';
  }

  private buildShareLinks() {
    const url = this.catalogHomeUrl() || this.getTargetUrl();

    if (!url) {
      this.shareLinks = { facebook: '#', linkedin: '#', twitter: '#', whatsapp: '#' };
      return;
    }

    const u = encodeURIComponent(url);
    const text = encodeURIComponent('Check this out');

    this.shareLinks = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
      twitter: `https://twitter.com/intent/tweet?url=${u}&text=${text}`,
      whatsapp: `https://api.whatsapp.com/send?text=${text}%20${u}`,
    };
  }

  private toFeaturedProductUrl(currentUrl: string, productId: string, tab: string = 'featured'): string {
    try {
      const u = new URL(currentUrl);
      const hash = u.hash.startsWith('#') ? u.hash.slice(1) : u.hash; // "/deal/organization?organizationId=..."
      const [hashPath, hashQuery = ''] = hash.split('?');

      const params = new URLSearchParams(hashQuery);
      const orgId = params.get('organizationId') || '';
      if (orgId) params.set('organizationId', orgId);
      params.set('tab', tab);
      const slug = this.currentUserData?.slug;

      const newHash = `#/${slug ?? 'deal'}/featured-product-details/${encodeURIComponent(productId)}?${params.toString()}`;
      return `${u.origin}${u.pathname}${u.search}${newHash}`;
    } catch {
      return currentUrl;
    }
  }

  getFeaturedList(): Promise<any[]> {
    return firstValueFrom(this.utilityService.getProductDetails(this.userID))
      .then((result: any) => {
        this.featuredList = result?.data ?? [];
        return this.featuredList;
      })
      .catch(() => {
        this.featuredList = [];
        return this.featuredList;
      });
  }

  private buildFeaturedOrgUrl(baseUrl: string): string {
    try {
      const u = new URL(baseUrl);
      const hash = u.hash.startsWith('#') ? u.hash.slice(1) : u.hash; // e.g. "/deal/organization?organizationId=..."
      const [, hashQuery = ''] = hash.split('?');

      const params = new URLSearchParams(hashQuery);
      const orgId = params.get('organizationId') || this.getCurrentUserId() || '';

      if (orgId) params.set('organizationId', orgId);
      params.set('tab', 'featured');

      const newHash = `#/deal/organization?${params.toString()}`;
      return `${u.origin}${u.pathname}${u.search}${newHash}`;
    } catch {
      const orgId = this.getCurrentUserId() || '';
      const origin = (this.baseurl || window.location.origin + '/').replace(/\/+$/, '');
      return `${origin}#/deal/organization?tab=featured${orgId ? `&organizationId=${encodeURIComponent(orgId)}` : ''}`;
    }
  }



  private isStoreOnlyUser(): boolean {
    const types: string[] = this.currentUserData?.userType ?? [];
    const isStore = types.includes(UserTypeEnum.RETAILER);
    const isOrg = [
      UserTypeEnum.ORGANIZATION,
      UserTypeEnum.ORGANIZATION_CATALOG,
      UserTypeEnum.BASE_ORGANIZATION,
      UserTypeEnum.ORGANIZATION_LITE,
    ].some(type => types.includes(type));
    return isStore && !isOrg;
  }

  private applyCopyUrl(responseQr: any): void {
    if (!responseQr?.success) return;
    this.businessQRValue = responseQr.data.qrCodeValue;
    this.qrCodeValue = responseQr.data.shareUrl || this.businessQRValue || '';
    if (this.catalogHomeUrl()) {
      this.getqrcode();
    } else {
      this.businessQRCode = responseQr.data.qrCodeURL;
    }
    this.buildShareLinks();
  }

  private loadSidebarCopyUrl(): void {
    const request = this.isStoreOnlyUser()
      ? this.retailStoreService.generate_qrcode()
      : this.businessuserService.generate_qrcode();
    request.subscribe((responseQr: any) => this.applyCopyUrl(responseQr));
  }

  private loadPublishDealCatalog(): void {
    this.businessuserService.getQrSite().subscribe((response: any) => {
      const data = response?.data ?? response;
      if (response?.success === false || data?.isAlyroUser == null) return;
      this.showPublishDealCatalog = !!data.isAlyroUser;
      this.publishDealCatalog = !!data.published;
    });
  }

  async resolveCopyUrl(): Promise<string> {
    const home = this.catalogHomeUrl();
    if (home) return home;

    const baseUrl = this.getTargetUrl() || this.baseurl;
    if (!baseUrl) return '';
    if (this.isStoreOnlyUser()) return baseUrl;

    const list = await this.getFeaturedList();
    const picked = Array.isArray(list) ? list.find((it: any) => it?.featureToggle === true) : null;
    const pid = picked?._id ?? picked?.id ?? picked?.productId;
    return pid ? this.toFeaturedProductUrl(baseUrl, pid) : this.buildFeaturedOrgUrl(baseUrl);
  }

  async onPublishDealCatalog(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const enabled = input.checked;
    if (this.publishingDealCatalog) {
      input.checked = this.publishDealCatalog;
      return;
    }
    this.publishingDealCatalog = true;
    const url = enabled ? await this.resolveCopyUrl() : '';
    if (enabled && !url) {
      input.checked = false;
      this.publishingDealCatalog = false;
      this.alertService.showError('Copy URL is not available');
      return;
    }
    this.businessuserService.updateQrSite({enabled, url}).subscribe((response: any) => {
      this.publishingDealCatalog = false;
      if (!response?.success) {
        input.checked = this.publishDealCatalog;
        this.alertService.showError(response?.message || 'Unable to update Publish to Alyro');
        return;
      }
      this.publishDealCatalog = !!response.data?.published;
      input.checked = this.publishDealCatalog;
    }, () => {
      this.publishingDealCatalog = false;
      input.checked = this.publishDealCatalog;
      this.alertService.showError('Unable to update Publish to Alyro');
    });
  }

  async onClickCopyURL() {
    const url = await this.resolveCopyUrl();
    if (!url) return;
    this.clipboard.copy(url);
    this.alertService.showSuccess('Link copied');
  }

  getqrcode() {
    const home = this.catalogHomeUrl();
    if (!home) return;
    this.businessQRValue = home;
    this.qrCodeValue = home;
    QRCode.toDataURL(home)
      .then((url: any) => {
        this.businessQRCode = url;
      })
      .catch((err: any) => {
        console.error('Error generating QR code', err);
      });
  }

  onShareInstagram() {
    let url = this.catalogHomeUrl() || this.getTargetUrl();
    if (!url) return;
    url = this.addSourceToUrl(url, 'instagram')
    this.clipboard.copy(url);
    window.open('https://www.instagram.com/', '_blank', 'noopener');
  }

  addSourceToUrl(url: string, source: string): string {
    const [basePart, hashPart] = url.split('#');

    if (!hashPart) return url; // no hash route, nothing to do

    const [route, existingQuery] = hashPart.split('?');
    const searchParams = new URLSearchParams(existingQuery || '');

    searchParams.set("source", source);

    return `${basePart}#${route}?${searchParams.toString()}`;
  }

  openShareDialog(tpl: TemplateRef<any>) {
    this.buildShareLinks();
    this.dialog.open(tpl, { width: '420px', autoFocus: false });
  }

  private buildFinalShareUrl(): string {
    return this.catalogHomeUrl() || this.getTargetUrl() || '';
  }

  async onOpenProductList() {
    let url = this.catalogHomeUrl();
    if (!url) {
      const baseUrl = this.getTargetUrl() || this.baseurl;
      if (!baseUrl) return;

      const list = await this.getFeaturedList();

      const picked = Array.isArray(list) ? list.find((it: any) => it?.featureToggle === true) : null;
      const pid = picked?._id ?? picked?.id ?? picked?.productId;

      url = pid
        ? this.toFeaturedProductUrl(baseUrl, pid)
        : this.buildFeaturedOrgUrl(baseUrl);
    }

    if (!url) { return; }

    const w = window.open(url, '_blank');
    if (w) {
      w.opener = null;
    } else {
      window.location.href = url;
    }
  }

}
